import { ProjectDisplay } from "./ProjectDisplay";
import { ProjectNav } from "./ProjectNav";

const ProjectComponents = { ProjectDisplay, ProjectNav };

export default ProjectComponents;
